export interface DateFundFilterDialog {
  [key: string]: any;
}
